import { Component, ViewChild} from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, Content } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
import { HttpParams, HttpClient } from '@angular/common/http';

import { RequestsProvider } from '../../providers/requests/requests';
/**
 * Generated class for the ExpensePopUpPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-expense-pop-up',
  templateUrl: 'expense-pop-up.html',
})
export class ExpensePopUpPage {
  expense_ddl: any = [];
  description: string="";
  amount: string="";
  taxapplies: string="1";
  taxappliestxt: string="No";
  payment: string="P";
  expensetypeid: string="8";
  expensetypetxt: string="Other";
  expenses_data: any = [];
  xmlString: string="";
  GUID: string = "";
  
  public base64Files: string[] = [];
  public base64FilesNames: string[] = [];
  private files: any[] = [];
  private fileReader = new FileReader();

  body: string = "INSTRUCTIONS: To attach an image to this expense entry simply attach it to this mail and press send.%0D%0A %0D%0ANOTE: Do not alter the subject or to address.%0D%0A %0D%0AYour email must be sent from the email address that you login with. %0D%0A %0D%0APlease allow up to 5 minutes for your image to be received and processed, after which time your image will be visible on the expense form.%0D%0A %0D%0A";
  toEmailAddress: string = "expenses@thetimegenie.co.uk";
  
  displayexpensemode:boolean= false;
  addexpensemode:boolean= true;

  expenses_taxhandling: number = 0;
  expenses_imageupload: number = 0;
  showsummary : boolean= false;
  @ViewChild(Content) content: Content;
  
  constructor(public navCtrl: NavController, public navParams: NavParams
    , public viewCtrl: ViewController
    , public global: GlobalProvider
    , public http: HttpClient
    , public requests:RequestsProvider
  ) {

      this.expense_ddl = navParams.get('expense_ddl');
      this.expenses_data = navParams.get('expense_data');
      this.expenses_taxhandling = navParams.get('expenses_taxhandling');
      this.expenses_imageupload = navParams.get('expenses_imageupload');

  }
  
  uploadreceipt(){
    let data = {
      description: this.description,
      expensetypeid: this.expensetypeid ,
      amount: this.amount,
      payment: this.payment,
      taxapplies: this.taxapplies
     };
    this.httprequest_save_expenses(data);
  }
  dismiss() {
    this.viewCtrl.dismiss({expenses_data: this.expenses_data});
  }
  httprequest_save_expenses(data: any){
    if(data.description.trim() == "" || data.amount == "") { this.global.presentToast("Please enter description and amount values");return;}
    if(!data) return;
    //fill in expenses_data with current expense details
    var indxEmptyExpense = this.expenses_data.findIndex(function(item, i){
      return item.ExpenseEntryId === 0
    });

    this.expenses_data[indxEmptyExpense].Description = data.description;
    this.expenses_data[indxEmptyExpense].TaxApplies = data.taxapplies;
    this.expenses_data[indxEmptyExpense].Payment = data.payment.toUpperCase();
    this.expenses_data[indxEmptyExpense].Amount = parseFloat(data.amount).toFixed(2);
    this.expenses_data[indxEmptyExpense].ExpenseTypeId = parseInt(data.expensetypeid);


    this.CreateExpensesXML();
    this.CalculateExpenses();

    // debugger
    var p: any = {};
    //p.sp_name = "sp_expenses_write";
    p.timesheetid = this.global.timesheetid;
    p.timesheetentriesid = '0';
    p.miles = String(this.global.miles.toFixed(2));
    p.mileagerate = String(this.global.mileage_rate.toFixed(2));
    p.milesamount = String(this.global.miles_amount.toFixed(2));
    p.totalexpenses = String(this.global.total_expenses.toFixed(2));
    p.grandtotal = String(this.global.grand_total.toFixed(2));
    
    p.xml = this.xmlString.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&apos;");

    // console.log(p.xml);
    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/expenses_save/',params).subscribe(

      (data: any) => {        
        var saveresult = JSON.parse(data.dt);
        var lastAddedExpenseId = JSON.parse(saveresult)[0].ExpenseEntryId;

        this.httpRequestExpenses_read(lastAddedExpenseId);
      },
      error => {
        alert(error);
        this.global.presentToast('An error occured!');
      }
    );

  }

  httpRequestExpenses_read(lastAddedExpenseId: string){
    
    //j: {"sp_name":"sp_expenses_read","UserId":0,"TimesheetId":"5208","TimesheetEntriesID":"0"}
    this.global.createLoader();
    this.global.loading.present().then((result) => {

      var p:any={};
      p.timesheetid = this.global.timesheetid;
      p.contacttype = this.global.contacttype;
      p.timesheetentriesid = '0';
      p.userid = '0';

      const params = new HttpParams()
      .set('j',JSON.stringify(p))


      this.http.post('timesheets/expenses_read/',params).subscribe(

        (data) => {
          //debugger

          this.global.loading.dismiss();
          var resexpenses: any = data;
          if (resexpenses.result == true) {
            this.global.dt_expenses = JSON.parse(resexpenses.dt);
            this.expenses_data = JSON.parse(this.global.dt_expenses[1]); 
            for (var i=0; i < this.expenses_data.length;i++){
              
              var amount = this.expenses_data[i].Amount;
              this.expenses_data[i].Amount = amount.toFixed(2);

              var pay = this.expenses_data[i].Payment;
              this.expenses_data[i].Payment = pay? pay: "P";
            }
                  
            if(!lastAddedExpenseId) {this.global.presentToast("An error occurred while saving the expenses");return;}

            this.showsummary = true;            
            
            var lastAddedIndex = this.expenses_data.findIndex(function(item, i){
              return item.ExpenseEntryId === lastAddedExpenseId
            });  

            this.GUID = this.expenses_data[lastAddedIndex].GUID;

            this.expensetypetxt = this.expenses_data[lastAddedIndex].ExpenseType;
            this.amount = String(parseFloat(this.expenses_data[lastAddedIndex].Amount).toFixed(2));
            
            var taxapplies = this.expenses_data[lastAddedIndex].TaxApplies;
            this.taxappliestxt = taxapplies == 1 ? "No" : taxapplies == 2 ? "Yes" : "";
          }
          
        },
        error => {
          this.global.presentToast("An error occurred!");
        }
      );

    }).catch((err) => {

    });


  }
  CreateExpensesXML() {
    this.xmlString = "";
    for (var i = 0; i < this.expenses_data.length; i++){
        if( this.expenses_data[i].Amount == "") this.expenses_data[i].Amount="0.00";

        this.xmlString = this.xmlString + "<row> <ExpenseEntryId>" 
        + String(this.expenses_data[i].ExpenseEntryId )
        + "</ExpenseEntryId> <Value> " 
        + String(parseInt(this.expenses_data[i].Amount).toFixed(2))  
        + " </Value> <Description> " 
        +  this.expenses_data[i].Description 
        + " </Description> <ExpenseTypes> " 
        +  String(this.expenses_data[i].ExpenseTypeId )
        + " </ExpenseTypes> <Payment> " 
        +  this.expenses_data[i].Payment 
        + " </Payment> <TaxApplies> " 
        +  String(this.expenses_data[i].TaxApplies?this.expenses_data[i].TaxApplies: 0) + " </TaxApplies> </row>";
    }

    this.xmlString = "<tabexpenses2>" + this.xmlString + "</tabexpenses2>";
  }

  CalculateExpenses(){
    //Miles    Total Number of Miles
    //MileageRate   
    //MilesAmount = Miles * MileageRate
    //TotalExpenses = Total of Everything that is not miles
    //GrandTotal = MilesAmount + TotalExpenses

    this.global.miles = 0;
    this.global.miles_amount = 0;
    this.global.total_expenses = 0;
    this.global.grand_total = 0;

    for (var i = 0; i < this.expenses_data.length; i++){
      if(this.expenses_data[i].ExpenseTypeId == 9) {
        this.global.miles = this.global.miles + parseFloat(this.expenses_data[i].Amount);
      }
      else {
        this.global.total_expenses = this.global.total_expenses + parseFloat(this.expenses_data[i].Amount);
      }
      
    }

    this.global.miles_amount = this.global.miles * this.global.mileage_rate;
    this.global.grand_total = this.global.miles_amount + this.global.total_expenses;

  }

  uploadReceipt( event: Event, i :string ) {
    
    let files = event.target['files'];
    if(!files.length) return;

    const maxAllowedSize = 5 * 1024 * 1024; //5MB
    if (files[0].size > maxAllowedSize) {
      alert('File size is very big. Please limit to 5MB.');
      return;
    }

    let formData = new FormData();
    formData.append('files[]', files[0], files[0].name);

    formData.append('body' , this.body);
    formData.append('GUID' , this.GUID);
    formData.append('subject' , this.GUID);
    formData.append('ToEmailAddress' , this.toEmailAddress);
    formData.append('UserName' , localStorage.getItem('username'));
    
    this.global.createLoader();
    this.global.loading.present().then((result) => {
      this.http.post('timesheets/upload_expenses_2/', formData ).subscribe(

        (data) => {
          this.global.loading.dismiss();
          this.global.presentToast('Image uploaded successfully.');
          if(this.requests.ExpensesDataReceived.observers.length==0){
            this.requests.ExpensesDataReceived.subscribe(
              () => {
                //console.log('Expenses Data Received.......... : ' );
                this.expenses_data = JSON.parse(this.global.dt_expenses[1]); 
                for (var i=0; i< this.expenses_data.length;i++){
                  // debugger
                  var amount = this.expenses_data[i].Amount;
                  this.expenses_data[i].Amount = amount.toFixed(2);

                  var pay = this.expenses_data[i].Payment;
                  this.expenses_data[i].Payment = pay? pay: "P";

                }

                this.dismiss();
                //this.global.tab2index = this.global.ndays - 1;
                //this.navCtrl.push(TimesheetType3Page, {TAB2ID: this.global.TAB2id[this.global.tab2index]});
              }
            );
          }
          //var dd: any;
          this.requests.httpRequestExpenses_read();
          
          
          this.base64Files=[];
          this.base64FilesNames=[];
          
        },
        error => {
          alert(error);
        }
      );
    }).catch((err) => {

    });

  }

  // uploadReceipt(event: Event, i :string) {    
  //   let files = event.target['files'];
    
  //   if (event.target['files']) {
  //     this.readFiles(event.target['files'], 0);
  //   }
  // };

  // readFiles(files: any[], index: number) {
  //   let file = files[index];
  //   this.fileReader.onload = () => {
  //     // debugger
  //     // console.log(this.fileReader.result);
  //     var img = document.createElement("img");

  //     // if(this.resize){
  //     // debugger
  //     img.src = this.fileReader.result.toString();
  //     img.onload = () => {
  //       var canvas = document.createElement("canvas");
  //       //var canvas = $("<canvas>", {"id":"testing"})[0];
  //       var ctx = canvas.getContext("2d");
  //       ctx.drawImage(img, 0, 0);

  //       var MAX_WIDTH = 400;
  //       var MAX_HEIGHT = 400;
  //       var width = img.width;
  //       var height = img.height;

  //       if (width > height) {
  //         if (width > MAX_WIDTH) {
  //           height *= MAX_WIDTH / width;
  //           width = MAX_WIDTH;
  //         }
  //       } else {
  //         if (height > MAX_HEIGHT) {
  //           width *= MAX_HEIGHT / height;
  //           height = MAX_HEIGHT;
  //         }
  //       }
  //       canvas.width = width;
  //       canvas.height = height;
  //       var ctx = canvas.getContext("2d");
  //       ctx.drawImage(img, 0, 0, width, height);
        
  //       // debugger
        
  //       var dataurl = canvas.toDataURL("image/png");
        
  //       this.base64FilesNames.push(file.name);
  //       this.base64Files.push(dataurl);
  //       if (files[index + 1]) {
  //         this.readFiles(files, index + 1);
  //       } else {
  //         //console.log('loaded all files');
  //         this.uploadReceipt_toServer();
  //       }
  //     }
      
  //   };
  //   this.fileReader.readAsDataURL(file);
  // }


  // uploadReceipt_toServer() {

  //   var p: any = {};
  //   p.body = this.body;
  //   p.GUID = this.GUID;
  //   p.subject = this.GUID;
  //   p.ToEmailAddress = this.toEmailAddress;
  //   p.UserName = localStorage.getItem('username');
  //   p.attachments = this.base64Files;
  //   p.attchementsNames = this.base64FilesNames;

  //   const params = new HttpParams()
  //   .set('j', JSON.stringify(p))

  //   this.global.createLoader();
  //   this.global.loading.present().then((result) => {
  //     this.http.post('timesheets/upload_expenses/', params ).subscribe(

  //       (data) => {
  //         this.global.loading.dismiss();
  //         this.global.presentToast('Image uploaded successfully.');
  //         if(this.requests.ExpensesDataReceived.observers.length==0){
  //           this.requests.ExpensesDataReceived.subscribe(
  //             () => {
  //               //console.log('Expenses Data Received.......... : ' );
  //               this.expenses_data = JSON.parse(this.global.dt_expenses[1]); 
  //               for (var i=0; i< this.expenses_data.length;i++){
  //                 // debugger
  //                 var amount = this.expenses_data[i].Amount;
  //                 this.expenses_data[i].Amount = amount.toFixed(2);

  //                 var pay = this.expenses_data[i].Payment;
  //                 this.expenses_data[i].Payment = pay? pay: "P";

  //               }

  //               this.dismiss();
  //               //this.global.tab2index = this.global.ndays - 1;
  //               //this.navCtrl.push(TimesheetType3Page, {TAB2ID: this.global.TAB2id[this.global.tab2index]});
  //             }
  //           );
  //         }
  //         //var dd: any;
  //         this.requests.httpRequestExpenses_read();
          
          
  //         this.base64Files=[];
  //         this.base64FilesNames=[];
          
  //       },
  //       error => {
  //         alert(error);
  //       }
  //     );
  //   }).catch((err) => {

  //   });

  // }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ExpensePopUpPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/expense-pop-up/expense-pop-up.ts